import * as React from 'react';
import { useSessionStorage } from '@mantine/hooks';

// Components
import { LanguageSelector } from '../LanguageSelector';

//
import { AuthContext } from '../../contexts/Auth';

// Firebase
import { auth } from '../../firebase';

// Hooks
import { useCurrentParentLanguage } from '../../hooks/useCurrentParentLanguage';

// i18n
import i18n from '../../i18n';

interface ILanguageSelectClientProps {
    onChange?: (val: string) => void;
}

export const LanguageSelectClient: React.FC<ILanguageSelectClientProps> = ({ onChange }) => {
    const { authState } = React.useContext(AuthContext);
    const { code: currentLanguage } = useCurrentParentLanguage();
    const [selectedLang, setSelectedLang] = React.useState<string>(currentLanguage);
    const selectLanguage = React.useCallback(
        (lang: string) => {
            i18n.changeLanguage(lang).then(() => {
                setSelectedLang(lang);
                auth.languageCode = lang;
                onChange?.(lang);
            });
        },
        [setSelectedLang]
    );

    React.useEffect(() => {
        if (
            !localStorage.getItem(`has-selected-language`) &&
            authState &&
            !authState?.initializing &&
            authState.preferredLang &&
            currentLanguage !== authState.preferredLang
        ) {
            // localStorage.setItem(`has-selected-language`, 'true');
            selectLanguage(authState.preferredLang);
        } else if (!['en', 'es'].includes(currentLanguage)) {
            selectLanguage('en');
        }
    }, [currentLanguage, authState, selectLanguage]);

    return (
        <LanguageSelector
            selectedLang={selectedLang}
            onChange={(val: string) => {
                localStorage.setItem(`has-selected-language`, 'true');
                selectLanguage(val);
            }}
        />
    );
};
